import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { withLocalization } from 'bernie-l10n';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';
import { EGDSBadgeStandard } from '@egds/react-core/badge';
import { EgdsHeadingTagStyle, TextTheme, TextWeight, UITK_HEADING_SIZE_ACTIVITY } from '../../../../../../constants';
import { mapDisclaimerToMessageContent } from '../../../../../../utils/disclaimer';
import { useStores } from '../../../../../../utils/hooks';
import { objectArrayToArrayConversion } from '../../../../../../helpers/popup-message-array-helper';
import { ActivityFeature } from '../components/activity-feature';
import { MessageAnchor } from '../../../../../common/message-anchor';
export var ActivityCardContentTop = withLocalization(function (_a) {
  var _b, _c, _d, _e, _f, _g, _h;
  var activity = _a.activity,
    activityGroup = _a.activityGroup,
    l10n = _a.l10n;
  var hotelPickup = activity.features.hotelPickup;
  var formatText = l10n.formatText;
  var analytics = useStores().analytics;
  var activityReviewId = activityGroup ? "review-legal-disclaimer-dialog-".concat(activity.id, "-").concat(activityGroup) : "review-legal-disclaimer-dialog-".concat(activity.id);
  var enhancedCleaningFeature = activity.features.enhancedCleaningFeature;
  var activityDuration = activity.activityDuration;
  var primary = activity.primary;
  var disclaimer = (_b = activity === null || activity === void 0 ? void 0 : activity.reviewSummary) === null || _b === void 0 ? void 0 : _b.disclaimer;
  var _j = mapDisclaimerToMessageContent(disclaimer),
    icon = _j.icon,
    content = _j.content,
    disclaimerDialog = _j.disclaimerDialog,
    triggerAnalytics = _j.triggerAnalytics;
  var reviewRatingBadge = (_c = activity === null || activity === void 0 ? void 0 : activity.reviewSummary) === null || _c === void 0 ? void 0 : _c.reviewRatingBadge;
  var reviewSuperlative = (_d = activity === null || activity === void 0 ? void 0 : activity.reviewSummary) === null || _d === void 0 ? void 0 : _d.reviewSuperlative;
  var _k = reviewRatingBadge || {},
    badgeA11yText = _k.accessibility,
    badgeSize = _k.size,
    badgeText = _k.text,
    badgeTheme = _k.theme;
  var _l = reviewSuperlative || {},
    superlativeTheme = _l.theme,
    text = _l.text,
    superlativeWeight = _l.weight,
    superlativeSize = _l.size;
  return React.createElement(UitkLayoutFlex, {
    tag: "section",
    direction: "column",
    "data-testid": "activity-tile-card-content-top"
  }, enhancedCleaningFeature && React.createElement(UitkSpacing, {
    padding: {
      blockend: 'one'
    }
  }, React.createElement(UitkLayoutFlexItem, {
    className: "uitk-type-200"
  }, React.createElement(ActivityFeature, {
    label: enhancedCleaningFeature.text,
    icon: enhancedCleaningFeature.icon,
    "data-testid": "activity-enhanced-cleaning"
  }))), React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkHeading, {
    tag: primary.headingType ? EgdsHeadingTagStyle[primary.headingType] : 'h3',
    size: UITK_HEADING_SIZE_ACTIVITY,
    className: "custom-wrap-text overflow-wrap truncate-lines-3 full-width",
    "data-testid": "activity-tile-card--title"
  }, primary.text)), (activityDuration === null || activityDuration === void 0 ? void 0 : activityDuration.text) && React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'one'
    }
  }, React.createElement(UitkLayoutFlexItem, {
    className: "uitk-type-200"
  }, React.createElement(ActivityFeature, {
    label: activityDuration.text,
    a11yLabel: formatText('lx.search.activity.duration', activityDuration.text),
    icon: activityDuration.icon,
    "data-testid": "activity-duration--feature"
  }))), React.createElement(Experiment, {
    name: "Optimising_reviews_CTA_and_disclaimer"
  }, React.createElement(ExperimentControl, null, ((_e = activity.reviewSummary) === null || _e === void 0 ? void 0 : _e.reviewRatingMessage) && React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'one'
    }
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkLayoutFlex, {
    alignItems: "center",
    "data-testid": "activity-review-rating"
  }, React.createElement(UitkSpacing, {
    margin: {
      inlineend: 'one'
    }
  }, React.createElement(UitkText, {
    size: 300,
    weight: "bold",
    theme: "emphasis",
    "aria-label": activity.reviewSummary.reviewRatingAccessibilityText
  }, activity.reviewSummary.reviewRatingMessage)), React.createElement(UitkText, {
    size: 300,
    theme: "default"
  }, activity.reviewSummary.reviewCountMessage), disclaimer && React.createElement(MessageAnchor, {
    dialogId: activityReviewId,
    text: "",
    id: "review-info-".concat(activity.id),
    icon: icon,
    dismissAction: disclaimerDialog,
    disclaimer: disclaimer,
    messages: objectArrayToArrayConversion(content),
    triggerAnalytics: triggerAnalytics,
    anchorClasses: "uitk-type-300 type-gray",
    analytics: analytics,
    isNestedPopup: true,
    buttonType: "Link"
  }))))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, reviewRatingBadge && React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'one'
    }
  }, React.createElement(UitkLayoutFlexItem, {
    grow: 2
  }, React.createElement(UitkLayoutFlex, {
    space: "one",
    alignItems: "center",
    "data-testid": "activity-highlight-review"
  }, React.createElement(EGDSBadgeStandard, {
    text: badgeText || '',
    theme: badgeTheme,
    a11yText: badgeA11yText,
    size: badgeSize
  }), React.createElement(UitkLayoutFlex, {
    direction: "column"
  }, reviewSuperlative && React.createElement(UitkText, {
    theme: superlativeTheme ? TextTheme[superlativeTheme] : TextTheme.EMPHASIS,
    weight: superlativeWeight ? TextWeight[superlativeWeight] : TextWeight.BOLD,
    size: superlativeSize ? Number(superlativeSize) : 300
  }, text), ((_f = activity.reviewSummary) === null || _f === void 0 ? void 0 : _f.reviewCountMessage) && React.createElement(UitkText, {
    weight: "regular",
    size: 200
  }, (_g = activity.reviewSummary) === null || _g === void 0 ? void 0 : _g.reviewCountMessage))))))), ((_h = activity.features.travelDistance) === null || _h === void 0 ? void 0 : _h.label) && React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'two'
    }
  }, React.createElement(UitkLayoutFlexItem, {
    className: "uitk-type-200"
  }, React.createElement(ActivityFeature, {
    label: activity.features.travelDistance.label,
    "data-testid": "activity-travel-distance--feature"
  }))), hotelPickup && React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'two'
    }
  }, React.createElement(UitkLayoutFlexItem, {
    className: "uitk-type-200"
  }, React.createElement(ActivityFeature, {
    label: hotelPickup.label,
    icon: hotelPickup.icon_temp,
    "data-testid": "activity-hotel-pickup--feature"
  }))));
});